import { Navigate } from 'react-router-dom';
import { useSessionStorage } from '../../../hooks';
import { useNavigate } from 'react-router-dom';
import { setUnauthenticated } from '../../../utils/auth';
import React, { useState,useEffect } from 'react';
import LogoImg from '../../../assets/logo.svg';
import {
  Carpad,
  Container, Logo, LogoContainer,  MenuContainer, MenuContainerBottom, MenuIcon, MenuItem, MenuTitle, Slogan, SloganContainer

} from './styled';
import DashboardSelected from '../../../assets/icon-dashboard-selected.svg';
import AllScan_Unselected from '../../../assets/icon-allscan-unselected.svg';
import Department_Unselected from '../../../assets/icon-department-unselected.svg';
import Device_Unselected from '../../../assets/icon-device-unselected.svg';
import Engineer_Unselected from '../../../assets/icon-engineer-unselected.svg';
import Support_Unseleted from '../../../assets/icon-support-unseleted.svg';
import Setting_Unselected from '../../../assets/icon-setting-unselected.svg';
import logout from '../../../assets/logout.svg';  
import { useAppContext } from '../../../AppContext';

export const Menu = (props: any) => {
  const navigate = useNavigate();
  const[selectedMenu,setSelectedMenu]=useState('Dashboard')    
  const [authenticated, setAuthenticated] = useSessionStorage('authenticated');
  
  const [userType, setuserType] = useState(sessionStorage.userType); 
  const { state, dispatch } = useAppContext();


  useEffect(() => {
    if (sessionStorage.userType!="business")
    {
      setSelectedMenu("Scan") ;
    }
    else
    {
      setSelectedMenu("Dashboard");
      
    }
  }, []);
  const handleSelection  =async(menu:any)=>
  {
    setSelectedMenu(menu); 
    if(menu=="Dashboard")
    {
      navigate('/dashboard');     
      dispatch({ type: 'UPDATE_TOP_HEADER_TITLE', payload: menu});
    }
    if(menu=="My Devices")
    {
      dispatch({ type: 'UPDATE_TOP_HEADER_TITLE', payload: 'Devices'});
      navigate('/mydevices');   
    }
    if(menu=="Scan")
    {
      dispatch({ type: 'UPDATE_TOP_HEADER_TITLE', payload: 'Scan'});
      navigate('/scan');   
    }
    else if(menu=='All Scans')
    {
      dispatch({ type: 'UPDATE_TOP_HEADER_TITLE', payload: 'All Scan'});
      navigate('/allscan');   
    }
    else if(menu=='Customer Care')
    {
      dispatch({ type: 'UPDATE_TOP_HEADER_TITLE', payload: 'Customer Care'});
      navigate('/customercare');   
    }
    
    else if(menu=="Logout")
    {
      setUnauthenticated();
      navigate('/home'); 
    }
    else
    {
      dispatch({ type: 'UPDATE_TOP_HEADER_TITLE', payload: menu});
    }

       
    
  }

  if (authenticated)
    return (
      <Container>
        <LogoContainer>
          <Logo src={LogoImg}></Logo>
          <SloganContainer>
            <Carpad>Carpad</Carpad>
            <Slogan>Slogan goes here</Slogan>
          </SloganContainer>
        </LogoContainer>
        {userType !="business" && <MenuContainer>
         
          <MenuItem style={selectedMenu=='Scan'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('Scan')} >
            <MenuIcon src={AllScan_Unselected} /> 
            <MenuTitle style={selectedMenu=='Scan'?{fontWeight:700}:{}}>Scan</MenuTitle>
          </MenuItem>
          </MenuContainer>
        }
        {userType =="business" && <><MenuContainer>
         
          <MenuItem style={selectedMenu=='Dashboard'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('Dashboard')} >
            <MenuIcon src={DashboardSelected} /> 
            <MenuTitle style={selectedMenu=='Dashboard'?{fontWeight:700}:{}}>Dashboard</MenuTitle>
          </MenuItem>
              
          <MenuItem style={selectedMenu=='All Scans'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('All Scans')} >
            <MenuIcon src={AllScan_Unselected} /> 
            <MenuTitle style={selectedMenu=='All Scans'?{fontWeight:700}:{}}>All Scans</MenuTitle>
          </MenuItem>

          <MenuItem style={selectedMenu=='Departments'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('Departments')} >
            <MenuIcon src={Department_Unselected} /> 
            <MenuTitle style={selectedMenu=='Departments'?{fontWeight:700}:{}}>Departments</MenuTitle>
          </MenuItem>

          <MenuItem style={selectedMenu=='My Devices'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('My Devices')} >
            <MenuIcon src={Device_Unselected} /> 
            <MenuTitle style={selectedMenu=='My Devices'?{fontWeight:700}:{}}>My Devices</MenuTitle>
          </MenuItem>

          <MenuItem style={selectedMenu=='Customer Care'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('Customer Care')} >
            <MenuIcon src={AllScan_Unselected} /> 
            <MenuTitle style={selectedMenu=='Customer Care'?{fontWeight:700}:{}}>Customer Care</MenuTitle>
          </MenuItem>

          <MenuItem style={selectedMenu=='FLW'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('FLW')} >
            <MenuIcon src={Engineer_Unselected} /> 
            <MenuTitle style={selectedMenu=='FLW'?{fontWeight:700}:{}}>FLW</MenuTitle>
          </MenuItem>
          <MenuItem style={selectedMenu=='Support Center'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('Support Center')} >
            <MenuIcon src={Support_Unseleted  } /> 
            <MenuTitle style={selectedMenu=='Support Center'?{fontWeight:700}:{}}>Support Center</MenuTitle>
          </MenuItem>

        

        </MenuContainer>
        </>}
        <MenuContainerBottom>
        {userType =="business" && <> <MenuItem style={selectedMenu=='Settings'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('Settings')}
        
        
        >
            {/* <MenuIcon src={Setting_Unselected  } /> 
            <MenuTitle style={selectedMenu=='Settings'?{fontWeight:700}:{}}>Settings</MenuTitle> */}
          </MenuItem>
          </>}

          <MenuItem style={selectedMenu=='Logout'?{borderRadius:"4px",backgroundColor:'rgb(243, 244, 253)'}:{}} onClick={()=>handleSelection('Logout')} >
            <MenuIcon src={logout  } /> 
            <MenuTitle style={selectedMenu=='Logout'?{fontWeight:700}:{}}>Logout</MenuTitle>
          </MenuItem>



        </MenuContainerBottom>
      </Container>
    );
  return <Navigate to='/' replace />;

};
